import { createUseStyles } from 'react-jss'
import { BLUE } from '@omnilert/components'


const useStyles = createUseStyles({
  container: {
    backgroundColor: 'var(--primary__page__background)',
    background: 'transparent',
    marginBottom: '10px'
  },
  divider: {
    borderBottom: '1px solid var(--card-divider__color)',
    height: '2px',
    margin: '0px 15px 15px'
  },
  expandButton: {
    background: 'transparent',
    border: 'none',
    color: BLUE,
    fontSize: '14px',
    margin: '10px 15px',
    marginTop: 0,
    '&:hover': {
      cursor: 'pointer'
    }
  }
})

export default useStyles
